import { APP_ICONS } from './app.icons';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { registerIconsFactory } from 'src/app/shared/utils/common.utils';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-root',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col w-full h-full">
      <div class="flex-1 min-h-0 relative w-full">
        <router-outlet></router-outlet>
      </div>
    </div>
  `,
  imports: [RouterOutlet],
})
export class AppComponent {
  private readonly matIconRegistry = inject(MatIconRegistry);
  private readonly sanitizer = inject(DomSanitizer);

  constructor() {
    registerIconsFactory(this.matIconRegistry, this.sanitizer)(APP_ICONS);
  }
}
